import React from 'react';
import { Helmet } from 'react-helmet';
import PageNav from './components/PageNav';
import HeroSection from './components/HeroSection';
import MissionSection from './components/MissionSection';
import TeamSection from './components/TeamSection';
import TimelineSection from './components/TimelineSection';
import ValuesSection from './components/ValuesSection';

const OmOssAboutUs = () => {
  return (
    <>
      <Helmet>
        <title>Om Oss — NordPass | Vår Historie og Teamet Bak</title>
        <meta name="description" content="Lær om NordPass sin historie, misjon og teamet bak Norges ledende veiplattform. Grunnlagt i Oslo i 2019 av norske ingeniører og kartografer." />
        <link
          href="https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=Lora:ital,wght@0,400;0,700;1,400;1,700&family=Inter:wght@300;400;500;600&family=JetBrains+Mono:wght@400;500;700&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <div style={{ background: '#050A12', minHeight: '100vh', overflowX: 'hidden' }}>
        <PageNav />
        <HeroSection />
        <MissionSection />
        <TeamSection />
        <TimelineSection />
        <ValuesSection />

        {/* CTA Footer strip */}
        <section style={{
          background: '#3B6FD4',
          padding: '80px 5%',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: '-40px', right: '-40px',
            width: '300px', height: '300px',
            background: 'rgba(255,255,255,0.05)',
            borderRadius: '50%'
          }} />
          <div style={{ maxWidth: '1400px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '32px' }}>
            <div>
              <h2 style={{
                fontFamily: 'Syne, sans-serif',
                fontSize: 'clamp(1.75rem, 3vw, 2.5rem)',
                fontWeight: 800,
                color: '#EEF0F2',
                letterSpacing: '-0.03em',
                margin: '0 0 12px'
              }}>Bli en del av NordPass-familien</h2>
              <p style={{ fontFamily: 'Inter, sans-serif', fontSize: '1rem', color: 'rgba(238,240,242,0.8)', margin: 0 }}>
                47.000+ norske sjåfører stoler allerede på oss. Bli med i dag.
              </p>
            </div>
            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
              <a href="/login" style={{
                fontFamily: 'Syne, sans-serif',
                fontSize: '0.875rem',
                fontWeight: 700,
                color: '#3B6FD4',
                textDecoration: 'none',
                padding: '14px 28px',
                background: '#EEF0F2',
                letterSpacing: '0.06em',
                textTransform: 'uppercase'
              }}>START GRATIS</a>
              <a href="/nord-pass-contact-page" style={{
                fontFamily: 'Syne, sans-serif',
                fontSize: '0.875rem',
                fontWeight: 700,
                color: '#EEF0F2',
                textDecoration: 'none',
                padding: '14px 28px',
                border: '2px solid rgba(238,240,242,0.4)',
                letterSpacing: '0.06em',
                textTransform: 'uppercase'
              }}>KONTAKT OSS</a>
            </div>
          </div>
        </section>

        {/* Simple footer */}
        <footer style={{ background: '#050A12', padding: '40px 5%', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
          <div style={{ maxWidth: '1400px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
            <div style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.6875rem', color: 'rgba(138,149,163,0.4)', letterSpacing: '0.06em' }}>
              © 2026 NordPass AS — Alle rettigheter forbeholdt
            </div>
            <div style={{ display: 'flex', gap: '24px' }}>
              {[
                { label: 'Hjem', href: '/nord-pass-landing-page' },
                { label: 'Tjenester', href: '/tjenester-services' },
                { label: 'Kontakt', href: '/nord-pass-contact-page' }
              ]?.map((link, i) => (
                <a key={i} href={link?.href} style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '0.75rem',
                  color: 'rgba(138,149,163,0.4)',
                  textDecoration: 'none'
                }}>{link?.label}</a>
              ))}
            </div>
          </div>
        </footer>
      </div>
    </>
  );
};

export default OmOssAboutUs;
